<template>
  <div class="actions d-flex justify-content-center bg-transparent-dark">
    <div class="d-flex">
      <div class="content">
        <reaction
          @changed="(reaction) => reactionChanged(reaction, image)"
          :reactions="reactions"
          :user-reaction="userReaction"
          class="d-inline-block"
        >
          <ion-button v-show="!userReaction" color="primary" class="action" v-if="!isMobSmallScreen">
            <div class="d-flex align-items-center">
              <div class="text">🤩 React</div>
            </div>
          </ion-button>
          <ion-button v-show="userReaction" color="secondary" class="action" v-if="!isMobSmallScreen">
            <div class="d-flex align-items-center">
              <div class="text">{{ userReactionText }}</div>
            </div>
          </ion-button>
          <ion-button
            v-if="isMobSmallScreen"
            :color="!!image.user_reaction && image.user_reaction.reaction ? 'secondary' : 'primary'"
            class="action text-white"
          >
            <div class="d-flex">
              <i class="ti-thumb-up text-white" />

              <span class="mx-1 reaction-count text-white">{{ image.reaction_counts?.total_count }}</span>
            </div>
          </ion-button>
        </reaction>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Image, User } from '@/types/static-types';
import { Prop, Watch } from 'vue-property-decorator';
import namespace from '@/store/namespace';
import { Action, Getter } from 'vuex-class';
import { visualReactionsNames } from '@/statics/reactions';
import Reaction from '@/shared-components/VisualReaction.vue';
import { authStore } from '~/pinia-store/auth';
import { useWindowSize } from '~/composition/useWindowSize';

@Options({
  name: 'VisualPreviewReactions',
  components: { Reaction },
})
export default class VisualPreviewReactions extends Vue {
  @Prop() image!: Image;

  @Action('reactImage', { namespace: namespace.ImagesModule })
  public reactImage!: any;

  public get isAuthenticated() {
    const { isAuthenticated } = authStore()
    return isAuthenticated.value
  }

  public get user() {
    const { user } = authStore();
    return user.value;
  }

  public get reactions() {
    const { reaction_counts } = this.image || {};
    return reaction_counts;
  }

  public get windowWidth() {
    const { width } = useWindowSize()
    return width.value
  }

  public get isMobSmallScreen() {
    return this.windowWidth <= 500;
  }

  public get userReaction() {
    const { user_reaction } = this.image || {};
    return user_reaction;
  }

  public async reactionChanged(reaction: string, image: any) {
    const resp = await this.reactImage({ reaction, image });
    this.$emit('onReaction', { reactResp: resp, image });
  }

  public get userReactionText() {
    if (this.userReaction) return visualReactionsNames[this.userReaction.reaction];
    return '';
  }
}
</script>

<style lang="sass" scoped>
.inline-button
  height: 60px
  margin: 0 5px

.dark .actions
  background-color: #17074C !important

.actions
  background: #FFF
  border-top-right-radius: 10px
  border-top-left-radius: 10px
  .content
    max-width: 500px
    margin: auto

  .action
    font-size: 14px
    font-weight: bold
</style>
